export const COMPANYFOLDERLIST_SEARCH = 'COMPANYFOLDERLIST_SEARCH';
export const COMPANYFOLDERLIST_PAGE = 'COMPANYFOLDERLIST_PAGE';
